import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LuRefreshCw } from 'react-icons/lu';
import { useRouteError } from 'react-router-dom';

import { Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Sentry from '@sentry/react';

export const ErrorComponent = () => {
  const theme = useTheme();
  const routeError = useRouteError();
  const { t } = useTranslation();

  useEffect(() => {
    if (routeError) {
      Sentry.captureException(routeError);
    }
  }, [routeError]);

  return (
    <Grid
      container
      sx={{
        gap: 2,
        minHeight: '100vh',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Stack
        sx={{
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <LuRefreshCw color={theme.palette.primary.dark} size="9rem" />
        <Typography
          sx={{
            paddingTop: '4rem',
          }}
          variant="h2"
        >
          {t('common.error.title')}
        </Typography>
        <Typography
          sx={{
            paddingTop: '1rem',
          }}
          variant="h2"
        >
          {t('common.error.subtitle')}
        </Typography>
      </Stack>
    </Grid>
  );
};
